<template lang="pug">
#BlockedMsg
  //- Radio
  el-radio(v-if="transportType == 'ARRIVAL'") {{ $t('lang.transport.airTransferInPlace') }}
  el-radio(v-else) {{ $t('lang.transport.airTransferOutPlace') }}
  //- Mensajes
  .pnp-msg(v-if="transportType == 'ARRIVAL'") {{ arrivalTransfer }}
  .pnp-msg(v-else) {{ departureTransfer }}
</template>
<script>
import moment from 'moment'

export default {
  props: ['transportType', 'reservation'],
  computed: {
    arrivalTransfer () {
      return this.$t('lang.transport.airTransferIn').replace('<DATE>', moment(this.reservation.checkin).format('DD/MM/YYYY'))
    },
    departureTransfer () {
      return this.$t('lang.transport.airTransferOut').replace('<DATE>', moment(this.reservation.checkout).format('DD/MM/YYYY'))
    }
  }
}
</script>
<style lang="scss">
#BlockedMsg {
  text-align: left;
  padding: 22px;
  .btn {
    display: flex;
    justify-content: center;
    margin-top: 22px;
  }
}
</style>
